import { useDeleteASTFavorite } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_AST_FAVORITE';

type UseDeleteAstFavoriteReturnType = {
  handleDeleteAstFavorite: (astFavoriteId: string) => void;
};

export const useDeleteAstFavorite = (): UseDeleteAstFavoriteReturnType => {
  const { showSuccess, showError } = useNotification();
  const { mutate: deleteFavorite } = useDeleteASTFavorite();

  const handleDeleteAstFavorite = (astFavoriteId: string): void => {
    deleteFavorite(
      { astFavoriteId },
      {
        onSuccess: (): void => {
          showSuccess({
            title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
            message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
          });
        },
        onError: (error: AxiosError): void => {
          showError({
            title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
            message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
            error,
          });
        },
      }
    );
  };

  return { handleDeleteAstFavorite };
};
